import { render } from "./BoardDirectory.vue?vue&type=template&id=17ef1a1c&scoped=true"
import script from "./BoardDirectory.vue?vue&type=script&lang=js"
export * from "./BoardDirectory.vue?vue&type=script&lang=js"

import "./BoardDirectory.vue?vue&type=style&index=0&id=17ef1a1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ef1a1c"]])

export default __exports__